import React from "react";
import classNames from "classnames";
import { useChatCta } from "design_system/src/hooks/useChatCta";
import { ChatCtaV3 as ChatCTA } from "./ChatCTA";
import { HelpCenterCtaV3 as HelpCenterCTA } from "./HelpCenterCTA";
import { PhoneCTA } from "./PhoneCTA";

export interface NavBarHelpCTAsProps {
    helpCenterContext: {
        visible: boolean | null;
        helpCenterSidePanelVisible: boolean | null;
        phoneVisible: boolean | null;
        helpCenterUrl: string | null;
    };
    chatContext: {
        enabled: boolean | null;
        enabledNavbar: boolean | null;
    };
    providerPhoneNumber: string;
    isLoggedIn: boolean;
}

export const NavBarHelpCTAs = ({
    helpCenterContext,
    chatContext,
    providerPhoneNumber,
    isLoggedIn,
}: NavBarHelpCTAsProps) => {
    const { visible: isHelpCenterEnabled } = helpCenterContext;

    // Hybrid approach: backend state OR (base enabled AND recent activity from localStorage)
    const shouldShowChatCTA =
        chatContext.enabledNavbar || (chatContext.enabled && useChatCta(isLoggedIn));

    const ctaConfig = {
        helpCenter: isHelpCenterEnabled,
        chat: shouldShowChatCTA,
        phone: providerPhoneNumber,
    };

    if (ctaConfig.helpCenter || ctaConfig.chat) {
        return (
            <>
                {ctaConfig.helpCenter && (
                    <HelpCenterCTA
                        className={classNames({ "ml-24": ctaConfig.chat })}
                        helpCenterUrl={helpCenterContext.helpCenterUrl ?? undefined}
                    />
                )}
                {ctaConfig.chat && (
                    <ChatCTA className={classNames({ "ml-24": ctaConfig.helpCenter })} />
                )}
            </>
        );
    }
    if (helpCenterContext.phoneVisible && ctaConfig.phone) {
        return <PhoneCTA providerPhoneNumber={providerPhoneNumber} />;
    }
    return null;
};
